import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

function PieChartMember({ dashboardData }) {
  const [data, setData] = useState([]);
  const chartRef = useRef(null);

  useEffect(() => {
    if (dashboardData) {
      setData(dashboardData);
    }
  }, [dashboardData]);

  useLayoutEffect(() => {
    if (!data || data.length < 3) return;

    const root = am5.Root.new(chartRef.current);
    root.setThemes([am5themes_Animated.new(root)]);
    root._logo.dispose(); //remove logo

    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        endAngle: 270,
        innerRadius: am5.percent(60),
      })
    );

    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
        endAngle: 270,
        alignLabels: false,
      })
    );

    series.labels.template.setAll({
      text: "[bold]{category}[/]\n[bold]{value} ",
      centerX: am5.percent(50),
      centerY: am5.percent(50),
      fontSize: "16px",
      populateText: true,
      textType: "circular",
    });

    series.slices.template.setAll({
      fillOpacity: 1,
      strokeOpacity: 1,
      stroke: am5.color("#ffffff"),
      strokeWidth: 8,
      cornerRadius: 8,
    });

    series.slices.template.adapters.add("fill", (fill, target) => {
      return target.dataItem?.dataContext.color;
    });

    const pieData = [
      {
        category: "Logistics",
        value: data[1]?.total_count || 0,
        color: am5.color(0x0b4471),
      },
      {
        category: "Buyers",
        value: data[0]?.total_count || 0,
        color: am5.color(0x0096a2),
      },
      {
        category: "Suppliers",
        value: data[2]?.total_count || 0,
        color: am5.color(0x8cdf7f),
      },
    ];

    series.data.setAll(pieData);

    series.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [data]);

  return (
    <div className="chart-section main-chart">
      <div id="chartdiv" ref={chartRef} style={{ width: "100%", height: "350px" }}></div>
    </div>
  );
}


export default PieChartMember;
